var script_loaded=!1;
var activityEvents = [
        'mousedown', 'mousemove', 'keydown',
        'scroll', 'touchstart','click','keypress','touchmove'
    ];
let scripts = [...document.getElementsByTagName("script")].filter(e => e.dataset.src !== undefined);
let currentIndex = 0;

const loadScript = (script, callback) => {
  script.addEventListener("load", callback);
  script.defer = false;
  script.async = false;
  script.src = script.dataset.src;
  delete script.dataset.src;
}

function loadNext() {
  let activeScript = scripts[currentIndex];
  console.log(activeScript, currentIndex);
  if(currentIndex < scripts.length) {
  	loadScript(activeScript, loadNext)
  	currentIndex++; 
  }
  
}

const removeActivityListeners = () => {
  
  activityEvents.forEach(event => {
    window.removeEventListener(event, loadJSscriptsNow);
  });
};
function loadJSscripts(){
  setTimeout(function() {
  if(!script_loaded){
    script_loaded=!0;
    loadNext();
    var e=document.getElementsByTagName("link");
    for(i=0;i<e.length;i++)null!==e[i].getAttribute("data-href")&&(e[i].setAttribute("href",e[i].getAttribute("data-href")),delete e[i].dataset.href);
    
	setTimeout(function() {document.dispatchEvent(new CustomEvent("StartAsyncLoading"));document.dispatchEvent(new CustomEvent("StartKernelLoading"))},400)
  }},18000);

}

function loadJSscriptsNow(){
  if(!script_loaded){
    loadNext();
    var e=document.getElementsByTagName("link");
    for(i=0;i<e.length;i++)null!==e[i].getAttribute("data-href")&&(e[i].setAttribute("href",e[i].getAttribute("data-href")),delete e[i].dataset.href);
    setTimeout(function(){document.dispatchEvent(new CustomEvent("StartAsyncLoading"));document.dispatchEvent(new CustomEvent("StartKernelLoading"))},400);
    script_loaded=!0;
    removeActivityListeners();
  }
  else removeActivityListeners();

}

activityEvents.forEach(function(eventName) {
  window.addEventListener(eventName, loadJSscriptsNow, false);
});

document.addEventListener("load",loadJSscripts,false);
document.addEventListener("onload",loadJSscripts,false);

if(window.addEventListener != undefined ) {
window.addEventListener("load",loadJSscripts,false);
}
else if(window.attachEvent != undefined){
window.attachEvent("onload",loadJSscripts);
}
else {
  window.onload = loadJSscripts;
}